import acquisitionTypes, {
  acquisitionTypeTitles,
} from '../../support/acquisitionTypes';
import type { AcquisitionTypeRule } from './types';

const isEligibleNonSubscriber = (
  isSubscriptionExperienceActive: boolean,
  isAuthenticated: boolean,
  isRemembered: boolean,
  hasRfSubscription: boolean,
  isSubscriptionEligible: boolean
): boolean =>
  isSubscriptionExperienceActive &&
  (isAuthenticated || isRemembered) &&
  !hasRfSubscription &&
  isSubscriptionEligible;

const subscriptionLicenseRule: AcquisitionTypeRule = ({
  isAuthenticated,
  isRemembered,
  isSubscriptionExperienceActive,
  hasRfSubscription,
  isSubscriptionEligible,
  subscriptionOffer,
  assetIsPurchaseable,
}) => {
  if (
    !isEligibleNonSubscriber(
      isSubscriptionExperienceActive,
      isAuthenticated,
      isRemembered,
      hasRfSubscription,
      isSubscriptionEligible
    )
  )
    return null;
  if (!assetIsPurchaseable) return null;
  if (subscriptionOffer.kind !== 'subscription') return null;

  return {
    type: acquisitionTypes.SUBSCRIPTION_LICENSE,
    title: acquisitionTypeTitles.SUBSCRIPTION_LICENSE,
  };
};

export default subscriptionLicenseRule;
